import { render, staticRenderFns } from "./AddDetails.vue?vue&type=template&id=830e3d56&"
import script from "./AddDetails.vue?vue&type=script&lang=ts&"
export * from "./AddDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports